<template>
  <div class="container-fluid">
    <div class="row">
      <h2>
        {{ $t('entities.Questionnaire.Singular') }} {{ fullName }}
      </h2>
    </div>
    <div class="row">
      <div class="col-2">
        <div class="p-2"
             :class="getPollNavCssClass('personal-information', 1)"
             @click="currentStep = 1">
          {{ $t('Questionnaires.PersonalInformation') }}
        </div>
        <div class="p-2"
             :class="getPollNavCssClass('personal-anamnesis', 2)"
             @click="currentStep = 2">
          {{ $t('Questionnaires.PersonalAnamnesis') }}
        </div>
        <div class="p-2"
             :class="getPollNavCssClass('heart-vascular', 3)"
             @click="currentStep = 3">
          {{ $t('Questionnaires.CardioVascular') }}
        </div>
        <div class="p-2"
             :class="getPollNavCssClass('gynecology', 4)"
             @click="currentStep = 4"
             v-if="gender === 3">
          {{ $t('Questionnaires.Gynecology') }}
        </div>
        <div class="p-2"
             :class="getPollNavCssClass('urological-history', 4)"
             @click="currentStep = 4"
             v-if="gender === 2">
          {{ $t('Questionnaires.Urology') }}
        </div>
        <div class="p-2"
             :class="getPollNavCssClass('pregnancy', 5)"
             @click="currentStep = 5"
             v-if="gender === 3">
          {{ $t('Questionnaires.Pregnancy') }}
        </div>
        <div class="p-2"
             :class="getPollNavCssClass('gastro-disorders', 6)"
             @click="currentStep = 6">
          {{ $t('Questionnaires.GastroDisorders') }}
        </div>
        <div class="p-2"
             :class="getPollNavCssClass('neurodegenerative', 7)"
             @click="currentStep = 7">
          {{ $t('Questionnaires.Neurodegenerative') }}
        </div>
        <div class="p-2"
             :class="getPollNavCssClass('parents-anamnesis', 8)"
             @click="currentStep = 8">
          {{ $t('Questionnaires.ParentsAnamnesis') }}
        </div>
        <div class="p-2"
             :class="getPollNavCssClass('parents-family-anamnesis', 9)"
             @click="currentStep = 9">
          {{ $t('Questionnaires.ParentsFamilyAnamnesis') }}
        </div>
        <div class="p-2"
             :class="getPollNavCssClass('siblings-children-anamnesis', 10)"
             @click="currentStep = 10">
          {{ $t('Questionnaires.SiblingsChildrenAnamnesis') }}
        </div>
        <div class="p-2"
             :class="getPollNavCssClass('other-diseases', 11)"
             @click="currentStep = 11">
          {{ $t('Questionnaires.OtherDiseases') }}
        </div>
      </div>
      <div class="col-10">
        <PersonalInformation
          :id="Number(id)"
          v-if="currentStep === 1"
          @completed="finishedParts.push('personal-information')" />
        <PersonalAnamnesis
          :id="Number(id)"
          v-if="currentStep === 2"
          @completed="finishedParts.push('personal-anamnesis')" />
        <CardioVascular
          :id="Number(id)"
          v-if="currentStep === 3"
          @completed="finishedParts.push('heart-vascular')" />
        <Gynecology
          :id="Number(id)"
          v-if="currentStep === 4 && gender === 3"
          @completed="finishedParts.push('gynecology')" />
        <Urology
          :id="Number(id)"
          v-if="currentStep === 4 && gender === 2"
          @completed="finishedParts.push('urological-history')" />
        <Pregnancy
          :id="Number(id)"
          v-if="currentStep === 5 && gender === 3"
          @completed="finishedParts.push('pregnancy')" />
        <GastroDisorders
          :id="Number(id)"
          v-if="currentStep === 6"
          @completed="finishedParts.push('gastro-disorders')" />
        <Neurodegenerative
          :id="Number(id)"
          v-if="currentStep === 7"
          @completed="finishedParts.push('neurodegenerative')" />
        <ParentsAnamnesis
          :id="Number(id)"
          v-if="currentStep === 8"
          @completed="finishedParts.push('parents-anamnesis')" />
        <ParentsRelations
          :id="Number(id)"
          v-if="currentStep === 9"
          @completed="finishedParts.push('parents-family-anamnesis')" />
        <KidsRelative
          :id="Number(id)"
          v-if="currentStep === 10"
          @completed="finishedParts.push('siblings-children-anamnesis')" />
        <OtherDiseases
          :id="Number(id)"
          v-if="currentStep === 11"
          @completed="finishedParts.push('other-diseases')" />
      </div>
    </div>
  </div>
</template>
<script>
import PersonalInformation from '@components/poll/PersonalInformation';
import PersonalAnamnesis from '@components/poll/PersonalAnamnesis';
import CardioVascular from '@components/poll/CardioVascular';
import Gynecology from '@components/poll/Gynecology';
import Pregnancy from '@components/poll/Pregnancy';
import GastroDisorders from '@components/poll/GastroDisorders';
import Neurodegenerative from '@components/poll/Neurodegenerative';
import ParentsAnamnesis from '@components/poll/Parents';
import ParentsRelations from '@components/poll/ParentsRelations';
import KidsRelative from '@components/poll/KidsRelative';
import OtherDiseases from '@components/poll/OtherDiseases';
import Urology from '@components/poll/UrologicalHistory';

export default {
  components: {
    PersonalInformation,
    PersonalAnamnesis,
    CardioVascular,
    Gynecology,
    Pregnancy,
    GastroDisorders,
    Neurodegenerative,
    ParentsAnamnesis,
    ParentsRelations,
    KidsRelative,
    OtherDiseases,
    Urology
  },
  data() {
    return {
      currentStep: 1,
      fullName: '',
      finishedParts: [],
      gender: 1
    };
  },
  mounted() {
    this.axios.get('admin/questionnaires/completedparts', {
      params: {
        CustomerId: this.id
      }
    }).then((res) => {
      if (res.status === 404) {
        this.$router.push({ name: 'admin.customers.questionnaires.view' });
      } else {
        this.fullName = res.data.result.customer;
        this.finishedParts = res.data.result.parts;
        this.gender = res.data.result.gender;
      }
    });
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    getPollNavCssClass(part, step) {
      if (this.finishedParts.includes(part)) {
        if (this.currentStep === step) {
          return 'pollNavCompletedActive';
        }
        return 'pollNavCompleted';
      }
      if (this.currentStep === step) {
        return 'pollNavActive';
      }
      return 'pollNav';
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
  .pollNav {
    border: 1px solid black;
    background-color: $dp04;
    cursor: pointer;
  }

  .pollNavActive {
    border: 1px solid black;
    background-color: $dp08;
    cursor: pointer;
  }

  .pollNav:hover {
    background-color: $dp08;
  }

  .pollNavCompleted {
    border: 1px solid black;
    background-color: $completedPollPartColor;
    cursor: pointer;
  }

  .pollNavCompletedActive {
    border: 1px solid black;
    background-color: $completedPollPartColorActive;
    cursor: pointer;
  }

  .pollNavCompleted:hover {
    background-color: $completedPollPartColorActive;
  }
</style>
